import { render, staticRenderFns } from "./ValueOrNotAvailableInWarnColor.vue?vue&type=template&id=3d87ba7a&"
import script from "./ValueOrNotAvailableInWarnColor.vue?vue&type=script&lang=js&"
export * from "./ValueOrNotAvailableInWarnColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports